export const isMissingRequiredUserInfo = (email, firstName, lastName) =>
  !email || !firstName || !firstName.trim() || !lastName || !lastName.trim()
